<template>
  <div class="pt-2">
    <div :class="{ '!bg-success': light, '!text-black': light }" @click="toggleLight"
      class="h-[20px] w-[20px] text-xs text-g4 bg-g2 hover:!text-white hover:!bg-flyingeye-light flex items-center justify-center cursor-pointer px-[3px] py-[3px] ml-1 mb-1">
      <SVG name="lampe" css="fill-current"></SVG>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import API from "@/utils/API.js";
import SVG from "@/partials/SVG.vue";

export default {
  name: "DroneLight",
  props: {
    config: Object,
  },
  components: {
    SVG
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {
    toggleLight() {
      let light = this.config?.drone?.status?.night_lights_state != undefined
        ? this.config.drone.status.night_lights_state == 0
        : true;

      if (light) {
        let r = API.put('property', {
          "DockId": this.config?.dock?.id,
          "PropNameValue" : '"night_lights_state": 1'
        })

        toast.info(
          this.$e("Allumage de la lumière"),
          this.$root.toastConfig
        );
      }
      else {
        let r = API.put('property', {
          "DockId": this.config?.dock?.id,
          "PropNameValue" : '"night_lights_state": 0'
        })

        toast.info(
          this.$e("Extinction de la lumière"),
          this.$root.toastConfig
        );
      }
    }
  },

  computed: {
    light() {
      return this.config?.drone?.status?.night_lights_state != undefined
        ? this.config.drone.status.night_lights_state != 0
        : false;
    },
  },
};
</script>
